export const updateJobViewCount = (BeURL, id, showAlert) => {
    fetch(`${BeURL}/job-view-count`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ jobId: id })
    })
        .then(r => r.json())
        .then(({ success, message }) => {
            if (!success) showAlert(message);
        })
        .catch(err => {
            console.log("Error in Job view count:", err)
        });
}